import React, { useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogContent from '@material-ui/core/DialogContent'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Typography from '@material-ui/core/Typography'

import { useTranslation } from '../../../hooks'
import { ANALYTICS_HELPER } from '../../../utils'

const DialogTitle = (props) => {
	// eslint-disable-next-line no-unused-vars
	const { children, classes, onClose, ...other } = props
	return (
		<MuiDialogTitle disableTypography {...other} id="terms-dialog-title">
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className="btn-primary closeright" onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	)
}

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent)

function TermsDialog({ handleClose }) {
	const translate = useTranslation()

	useEffect(() => {
		// LOAD GTM EVENT
		ANALYTICS_HELPER._triggerEvent(ANALYTICS_HELPER.CATEGORY.NAVIGATION, {
			action: ANALYTICS_HELPER.EVENT.NAVIGATION.POPUP.TERMS.ACTION,
			label: ANALYTICS_HELPER.EVENT.NAVIGATION.POPUP.TERMS.LABEL,
			properties: {},
		})
	}, [])

	return (
		<>
			<DialogTitle onClose={() => handleClose()}></DialogTitle>
			<DialogContent id="terms-dialog-content">
				<Typography gutterBottom variant={'h5'}>
					{translate('DIALOG_CONTENT.TERMS.HEADING')}
				</Typography>
				<Typography gutterBottom>
					{translate('DIALOG_CONTENT.TERMS.CONTENT_1')}
					<br />
					{translate('DIALOG_CONTENT.TERMS.CONTENT_2')}
				</Typography>
			</DialogContent>
		</>
	)
}

export default TermsDialog
